import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { createSelector } from '@reduxjs/toolkit';
import { emptyArr } from '@beef/utils';
import { getNotificationsPreview, mapNotification } from "../components/Container/Notifications/utils";
import { NOTIFICATION_TYPE } from "../constants";
export var selectData = function selectData(state) {
  return state;
};
var selectAccountsData = function selectAccountsData(state) {
  var _selectData;
  return (_selectData = selectData(state)) === null || _selectData === void 0 ? void 0 : _selectData.accounts;
};
export var selectInitData = function selectInitData(state) {
  var _selectData2;
  return (_selectData2 = selectData(state)) === null || _selectData2 === void 0 ? void 0 : _selectData2.initData.data;
};
export var selectUserType = function selectUserType(state) {
  var _selectInitData;
  return (_selectInitData = selectInitData(state)) === null || _selectInitData === void 0 ? void 0 : _selectInitData.userType;
};
var selectCommonData = createSelector([selectData], function (data) {
  var _data$commonData$data, _data$commonData$data2;
  return data === null || data === void 0 ? void 0 : (_data$commonData$data = data.commonData.data) === null || _data$commonData$data === void 0 ? void 0 : (_data$commonData$data2 = _data$commonData$data.texts.find(function (item) {
    return item.key === 'side-menu-data';
  })) === null || _data$commonData$data2 === void 0 ? void 0 : _data$commonData$data2.content;
});
export var selectCommonDataError = function selectCommonDataError(state) {
  var _selectCommonData;
  return (_selectCommonData = selectCommonData(state)) === null || _selectCommonData === void 0 ? void 0 : _selectCommonData.error;
};
export var selectCommonDataPending = createSelector([selectCommonData, selectCommonDataError], function (commonData, commonDataError) {
  return (commonData === null || commonData === void 0 ? void 0 : commonData.pending) || commonDataError;
});
var selectDefaultAvatar = function selectDefaultAvatar(state) {
  var _selectCommonData2;
  return (_selectCommonData2 = selectCommonData(state)) === null || _selectCommonData2 === void 0 ? void 0 : _selectCommonData2.defaultAvatar;
};
export var selectNotAuthData = function selectNotAuthData(state) {
  var _selectData3;
  return (_selectData3 = selectData(state)) === null || _selectData3 === void 0 ? void 0 : _selectData3.notAuthData.data;
};
export var selectNotAuthPending = function selectNotAuthPending(state) {
  var _selectData4;
  return (_selectData4 = selectData(state)) === null || _selectData4 === void 0 ? void 0 : _selectData4.notAuthData.pending;
};
export var selectDefaultAccountsText = function selectDefaultAccountsText(state) {
  var _selectCommonData3;
  return (_selectCommonData3 = selectCommonData(state)) === null || _selectCommonData3 === void 0 ? void 0 : _selectCommonData3.defaultAccountsText;
};
export var selectNavigationList = function selectNavigationList(state) {
  var _selectCommonData4;
  return (_selectCommonData4 = selectCommonData(state)) === null || _selectCommonData4 === void 0 ? void 0 : _selectCommonData4.navigationList;
};
export var selectBaseUrl = function selectBaseUrl(state) {
  var _selectInitData2;
  return (_selectInitData2 = selectInitData(state)) === null || _selectInitData2 === void 0 ? void 0 : _selectInitData2.baseUrl;
};
export var selectAccountsError = function selectAccountsError(state) {
  var _selectAccountsData;
  return (_selectAccountsData = selectAccountsData(state)) === null || _selectAccountsData === void 0 ? void 0 : _selectAccountsData.error;
};
export var selectAccountsPending = createSelector([selectAccountsData, selectAccountsError], function (accountsData, accountsError) {
  return (accountsData === null || accountsData === void 0 ? void 0 : accountsData.pending) || accountsError;
});
export var selectAccounts = createSelector([selectData, selectDefaultAvatar], function (data, defaultAvatar) {
  var _data$accounts$data;
  return data === null || data === void 0 ? void 0 : (_data$accounts$data = data.accounts.data) === null || _data$accounts$data === void 0 ? void 0 : _data$accounts$data.map(function (account) {
    var _account$userType, _account$bens, _account$accounts;
    return {
      avatar: account.avatar || defaultAvatar,
      type: account.type.toLowerCase(),
      userType: (_account$userType = account.userType) === null || _account$userType === void 0 ? void 0 : _account$userType.toLowerCase(),
      number: account.number,
      login: account.login,
      ban: account.ban,
      isDefault: account.isDefault,
      formattedAccountNumber: account === null || account === void 0 ? void 0 : account.formattedAccountNumber,
      formattedNumber: account.formattedNumber,
      name: account.nickname,
      nickname: account.nickname,
      isSelected: account.isSelected,
      selectAccountUrl: account.selectAccountUrl,
      bens: account === null || account === void 0 ? void 0 : (_account$bens = account.bens) === null || _account$bens === void 0 ? void 0 : _account$bens.map(function (ben) {
        var _ben$accounts;
        return _objectSpread(_objectSpread({}, ben), {}, {
          type: ben.type.toLowerCase(),
          accounts: (_ben$accounts = ben.accounts) === null || _ben$accounts === void 0 ? void 0 : _ben$accounts.map(function (acc) {
            return _objectSpread(_objectSpread({}, acc), {}, {
              avatar: acc.avatar || defaultAvatar,
              userType: acc.userType.toLowerCase(),
              type: acc.type.toLowerCase()
            });
          })
        });
      }),
      accounts: account === null || account === void 0 ? void 0 : (_account$accounts = account.accounts) === null || _account$accounts === void 0 ? void 0 : _account$accounts.map(function (acc) {
        var _acc$type;
        return _objectSpread(_objectSpread({}, acc), {}, {
          avatar: acc.avatar || defaultAvatar,
          userType: acc.userType.toLowerCase(),
          type: (_acc$type = acc.type) === null || _acc$type === void 0 ? void 0 : _acc$type.toLowerCase()
        });
      }),
      selectAccountParams: account.selectAccountParams,
      isPostpaid: account.isPostpaid,
      formattedNotificationCtn: account.formattedNotificationCtn,
      limit: account.limit
    };
  });
});
export var selectAllAccounts = createSelector(selectAccounts, function (accounts) {
  var allAccounts = [];
  accounts === null || accounts === void 0 ? void 0 : accounts.forEach(function (account) {
    if (account.type !== 'ban' && account.type !== 'ben') {
      allAccounts.push(account);
    } else if (account.bens) {
      account.bens.forEach(function (ben) {
        ben.accounts.forEach(function (item) {
          return allAccounts.push(item);
        });
      });
    } else if (account.accounts) {
      account.accounts.forEach(function (item) {
        var _item$accounts;
        (_item$accounts = item.accounts) === null || _item$accounts === void 0 ? void 0 : _item$accounts.forEach(function (accountItem) {
          return allAccounts.push(accountItem);
        });
      });
    }
  });
  return allAccounts;
});
export var selectSelectedAccount = createSelector([selectAllAccounts, selectInitData], function (accounts, initData) {
  var filterIsSelectedAccount = function filterIsSelectedAccount(item) {
    return (item === null || item === void 0 ? void 0 : item.isSelected) || ((item === null || item === void 0 ? void 0 : item.formattedAccountNumber) || (item === null || item === void 0 ? void 0 : item.formattedNumber)) === (initData === null || initData === void 0 ? void 0 : initData.formattedAccountNumber);
  };
  return accounts === null || accounts === void 0 ? void 0 : accounts.find(filterIsSelectedAccount);
});
export var selectAllAccountsWithoutSelected = createSelector([selectAllAccounts], function (accounts) {
  return (accounts === null || accounts === void 0 ? void 0 : accounts.filter(function (account) {
    return !account.isSelected;
  })) || null;
});
var selectNotificationsBlock = function selectNotificationsBlock(state) {
  return state === null || state === void 0 ? void 0 : state.notifications;
};
var selectNotificationsData = function selectNotificationsData(state) {
  var _selectNotificationsB;
  return (_selectNotificationsB = selectNotificationsBlock(state)) === null || _selectNotificationsB === void 0 ? void 0 : _selectNotificationsB.data;
};
export var selectPending = function selectPending(state) {
  return selectNotificationsBlock(state).pending;
};
export var selectInfos = function selectInfos(state) {
  var _selectNotificationsD;
  return (_selectNotificationsD = selectNotificationsData(state)) === null || _selectNotificationsD === void 0 ? void 0 : _selectNotificationsD.infos;
};
export var selectNotifications = createSelector(selectInfos, function (notifications) {
  return (notifications === null || notifications === void 0 ? void 0 : notifications.map(mapNotification)) || emptyArr;
});
export var selectNotificationsPreview = function selectNotificationsPreview(state) {
  return getNotificationsPreview(selectNotifications(state));
};
export var selectInfosLength = function selectInfosLength(state) {
  var _selectInfos;
  return (_selectInfos = selectInfos(state)) === null || _selectInfos === void 0 ? void 0 : _selectInfos.length;
};
export var selectSimplificationNotification = function selectSimplificationNotification(state) {
  var _selectInfos2;
  var simplificationNotification = (_selectInfos2 = selectInfos(state)) === null || _selectInfos2 === void 0 ? void 0 : _selectInfos2.find(function (notification) {
    return (notification === null || notification === void 0 ? void 0 : notification.type) === NOTIFICATION_TYPE.simplification;
  });
  if (!simplificationNotification) {
    return null;
  }
  return _objectSpread(_objectSpread({}, mapNotification(simplificationNotification)), {}, {
    href: simplificationNotification.link
  });
};